import React, { useEffect, useState } from "react";
import { DrawerComponent } from "../Sidebar/DrawerComponent";
import Logo from "../Logo/Logo";
import './style/navbar.css';
import { useLocation, useNavigate } from "react-router-dom";
import { openWhislist } from "../../../Redux/Action/action";
import { useDispatch, useSelector } from "react-redux";
import { CiHeart } from "react-icons/ci";

const Navbar = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [state, setState] = useState({ right: false, sidebarHeight: "100vh" });

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  const [navbarBackground, setNavbarBackground] = useState('transparent');
  const [navbarTextColor, setNavbarTextColor] = useState('white');

  const isopen = useSelector(state => state.wishlist.Whislist);

  const dispatch = useDispatch()
  const navigate = useNavigate();
  const location = useLocation();

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
    navigate("/");
  };


  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 100) {
        setNavbarBackground('white');
        setNavbarTextColor('gray');
      } else {
        setNavbarBackground('transparent');
        setNavbarTextColor('white');
      }
    };

    if (location.pathname === '/') {
      window.addEventListener('scroll', handleScroll);
    } else {
      setNavbarBackground('white');
      setNavbarTextColor('gray');
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [location]);

  const handleIconButtonClick = (event) => {
    if (!isopen) {
      event.stopPropagation();
    }
    toggleDrawer1('right', true)(event);
    dispatch(openWhislist(true));
  };
  const toggleDrawer1 = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
    if (!open) {
      dispatch(openWhislist(false));
    }
  };

  return (
    <div className="hidden navbar-show">
      <div className="border-b border-gray fixed top-0 left-0 z-50 w-full sm:p-2 md:p-5 lg:p-5" style={{ backgroundColor: navbarBackground, color: navbarTextColor }}>
        <div className="mx-auto flex items-center justify-between" style={{ maxHeight: '100vh' }}>
          <DrawerComponent isOpen={isDrawerOpen} onClose={toggleDrawer} />
          <span onClick={scrollTop}><Logo /></span>
          <div className="flex justify-between" style={{ paddingRight: '5px' }}>
            <span className=" text-3xl " onClick={handleIconButtonClick} style={{ color: 'black', paddingLeft: '10px', cursor: 'pointer' }}>
                <CiHeart />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
